/**
 * QueryProvider wrapper for JavaScript files
 * Re-exports the TypeScript QueryProvider for use in App.js
 * 
 * IMPORTANT: Uses the singleton queryClient from query-client.ts to ensure
 * all query operations use the same client instance with identical config.
 */
import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// Import singleton from TS file - webpack resolves .ts extensions
import { queryClient } from '../infrastructure/query/query-client.ts';

export const QueryProvider = ({ children, showDevTools = process.env.NODE_ENV === 'development' }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {showDevTools && (
        <ReactQueryDevtools
          initialIsOpen={false}
          position="bottom-right"
          buttonPosition="bottom-right"
        />
      )}
    </QueryClientProvider>
  );
};

export { queryClient };
export default QueryProvider;
